import { Pipe, PipeTransform } from '@angular/core';
import { Observable, isObservable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DirectoryColumn } from 'src/app/samwebDescription/samweb/directory/directory-column';

@Pipe({
   name: 'directoryColumnHeaderIsCallable',
})
export class DirectoryColumnHeaderIsCallablePipe implements PipeTransform {
   transform(directoryColumn: DirectoryColumn, defaultCallableColumn: DirectoryColumn | Observable<DirectoryColumn>): unknown {
      let defaultCallableColumn$: Observable<DirectoryColumn>;
      if (isObservable(defaultCallableColumn)) {
         defaultCallableColumn$ = defaultCallableColumn;
      } else {
         defaultCallableColumn$ = of(defaultCallableColumn);
      }
      return defaultCallableColumn$.pipe(map((callableColumn) => directoryColumn?.directoryColumnKey === callableColumn?.directoryColumnKey));
   }
}
